export default "__VITE_ASSET__xGKfjCll__"